import {generateRequest} from 'fallco-frontend-framework/src/js/classes/HttpManager/api_utilities.js';

const END_POINT = 'utilita';
const controller = 'crm_utilita/calcoli.php';
const calcolo_usufrutto = (settings, params, callback) => generateRequest(controller, settings, {action: "process" , data: params}, callback);
const calcolo_usufrutto_a_termine = (settings, params, callback) => generateRequest(controller, settings, {action: "process" , data: params}, callback);
const calcolo_proporzionale_repertorio_parzialmente_in_prezzovalore = (settings, params, callback) => generateRequest(controller, settings, {action: "process" , data: params}, callback);
const calcolo_plusvalenza_immobiliare = (settings, params, callback) => generateRequest(controller, settings, {action: "process" , data: params}, callback);
const calcolo_valore_immobiliare_rivalutato = (settings, params, callback) => generateRequest(controller, settings, {action: "process" , data: params}, callback);
const calcolo_credito_imposta_prima_casa = (settings, params, callback) => generateRequest(controller, settings, {action: "process" , data: params}, callback);
const calcolo_equo_compenso = (settings, params, callback) => generateRequest(controller, settings, {action: "process" , data: params}, callback);
const determinazione_importo_decadenza_agevolazioni_prima_casa = (settings, params, callback) => generateRequest(controller, settings, {action: "process" , data: params}, callback);
const download_pdf = (settings, params, callback) => generateRequest('crm_utilita/stampe/stampa_utilita', settings, {action: "print" , data: params}, callback);
const calcolo_valore_da_rendita_catastale =  (settings, params, callback) => generateRequest(controller, settings, {action: "process" , data: params}, callback);

const apiEndpoint = {
  calcolo_usufrutto,
  calcolo_usufrutto_a_termine,
  calcolo_proporzionale_repertorio_parzialmente_in_prezzovalore,
  calcolo_plusvalenza_immobiliare,
  calcolo_valore_immobiliare_rivalutato,
  calcolo_credito_imposta_prima_casa,
  calcolo_equo_compenso,
  download_pdf,
  calcolo_valore_da_rendita_catastale,
  determinazione_importo_decadenza_agevolazioni_prima_casa
}

export default apiEndpoint;